import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";
import { createDepartment } from "./departments";
import defaultValuesOld from "../scenarios/edu-scenarios";
import { isAppAccessUserFn } from "../../utils/users";

const orgs = defaultValuesOld().organization;

const addData = async (org) => {
  const isAppAccessUser = isAppAccessUserFn();
  const depts = isAppAccessUser
    ? [defaultValuesOld().departments[2]]
    : defaultValuesOld().departments;

  let name = "";
  let description = "";
  let orgId = "";
  if (org) {
    name = org.Name;
    description = org.Description;
    orgId = org.ID;
  }
  const departments = [];

  for (const [index, dep] of depts.entries()) {
    let dept = await createDepartment(null, orgId, dep, index + 1);
    departments.push(dept);
  }
  return {
    Name: name,
    Description: description,
    ID: orgId,
    CreatedOn: faker.date.past(),
    ModifiedOn: faker.date.past(),
    ParentOrganizationId: "",
    ModifiedBy: null,
    CreatedBy: 2,
    CustomerId: uuidv4(),
    Departments: departments,
  };
};

export const createOrganization = async (data) => {
  if (data) {
    return await addData(data);
  }
  const organizations = [];
  for (const org of orgs) {
    let _org = await addData(org);
    organizations.push(_org);
  }
  return organizations;
};
